import { Component, Input } from '@angular/core';
import { EditorConfigurationProvider } from '../../../services/editor-configuration.provider';
import { FieldModel } from '../../../view-model/field-model';
import { UserSettings } from '../../../store/user-settings/user-settings.action';

@Component({
  selector: 'app-forbidden-info',
  templateUrl: './forbidden-info.component.html',
  styleUrls: ['./forbidden-info.component.scss'],
})
export class ForbiddenInfoComponent {
  @Input() model: FieldModel<any>;
  @Input() userSettings: UserSettings;
  ruleShown: boolean = false;
  isRS: boolean;

  constructor(
    private editorConfigurationProvider: EditorConfigurationProvider
  ) {
    this.isRS = this.editorConfigurationProvider.isRS();
  }

  readonly infoMessage = this.editorConfigurationProvider.isRS()
    ? 'Dieses Feld ist mit den derzeitigen Eingaben nicht vorgesehen. Falls Sie dieses Feld befüllen wollen, müssen Sie zunächst eine Vorbedingung erfüllen.'
    : 'Dieses Feld ist im Formular aktuell nicht erlaubt. Möglicherweise sind Regeln in Bezug auf andere Felder verletzt.';
}
